<script setup lang="ts">
import { computed } from 'vue';
import { useThemeStore } from '../stores/theme';

const themeStore = useThemeStore();

const icon = computed(() => {
  switch (themeStore.preference) {
    case 'light':
      return 'sun';
    case 'dark':
      return 'moon';
    case 'system':
    default:
      return 'system';
  }
});

const title = computed(() => {
  switch (themeStore.preference) {
    case 'light':
      return 'Light mode (click for dark)';
    case 'dark':
      return 'Dark mode (click for system)';
    case 'system':
    default:
      return 'System theme (click for light)';
  }
});
</script>

<template>
  <button
    class="theme-toggle"
    @click="themeStore.cycleTheme()"
    :title="title"
    aria-label="Toggle theme"
  >
    <!-- Sun icon -->
    <svg v-if="icon === 'sun'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
    <!-- Moon icon -->
    <svg v-else-if="icon === 'moon'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
    <!-- System icon (monitor) -->
    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  </button>
</template>

<style scoped>
.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--color-header-border);
  border-radius: 6px;
  color: var(--color-header-text-muted);
  cursor: pointer;
  transition: all 0.2s;
}

.theme-toggle:hover {
  background: var(--color-header-hover);
  color: var(--color-header-text);
  border-color: var(--color-header-text);
}

.theme-toggle svg {
  width: 18px;
  height: 18px;
}
</style>
